import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';
import {
  catalogUrlKeys,
  type CatalogUrlKey,
} from '@/packages/courses/types/url-params';

const IGNORE_KEYS: CatalogUrlKey[] = [catalogUrlKeys.page, catalogUrlKeys.sort];

export const AppliedFiltersCounter = () => {
  const { params } = useCatalogFilters();

  const count = Object.entries(params).reduce((acc, [key, values]) => {
    if (IGNORE_KEYS.includes(key as CatalogUrlKey)) return acc;
    const arr = values ?? (typeof values === 'number' ? [String(values)] : []);
    const list = Array.isArray(arr) ? arr : [arr];
    return acc + list.filter(Boolean).length;
  }, 0);

  if (count === 0) return null;

  return <> ({count})</>;
};
